import Counter from "../Counter";

const Fcontent3 = () => {
  return (
    <section
      id="content-3"
      className="bg-snow content-3 wide-60 content-section division"
    >
      <div className="container">
        {/* TOP ROW */}
        <div className="top-row pb-50">
          <div className="row d-flex align-items-center">
            {/* IMAGE BLOCK */}
            <div className="col-md-5 col-lg-6">
              <div className="img-block left-column wow fadeInRight">
                <img
                  className="img-fluid"
                  src="/images/img-09.png"
                  alt="content-image"
                />
              </div>
            </div>
            {/* TEXT BLOCK */}
            <div className="col-md-7 col-lg-6">
              <div className="txt-block right-column wow fadeInLeft">
                {/* Section ID */}
                <span className="section-id txt-upcase">Totally Optimized</span>
                {/* Title */}
                <h2 className="h2-xs">Work smarter with integrated tools</h2>
                {/* Text */}
                <p className="p-lg">
                  Rush Studio integrates with your favorite cloud storage providers, 
                  allowing you to sync your documents and translations effortlessly. 
                  Focus on what matters most while we handle the file management.
                </p>
                {/* Tools List */}
                <div className="tools-list ico-40 mt-30">
                  {/* Text */}
                  <h6 className="h6-xl">Cloud Integrations:</h6>
                  {/* Icons - Using generic classes or placeholder spans for now if flaticon is standard */}
                  <span className="flaticon-google-drive text-black-50" />
                  <span className="flaticon-dropbox text-black-50" />
                  <span className="flaticon-onedrive text-black-50" />
                  <span className="flaticon-cloud-computing text-black-50" />
                </div>
              </div>
            </div>{" "}
            {/* END TEXT BLOCK */}
          </div>
        </div>{" "}
        {/* END TOP ROW */}
        {/* BOTTOM ROW */}
        <div className="bottom-row">
          <div className="row d-flex align-items-center">
            {/* TEXT BLOCK */}
            <div className="col-lg-6 order-last order-lg-2">
              <div className="txt-block slim-column left-column wow fadeInRight">
                {/* TEXT BOX */}
                <div className="txt-box mb-20">
                  {/* Title */}
                  <h5 className="h5-lg">Scalable for Any Team</h5>
                  {/* Text */}
                  <p className="p-lg">
                    Whether you're a freelance translator or a global agency, 
                    our platform scales to meet your needs. Add team members, 
                    assign roles, and manage permissions with ease.
                  </p>
                </div>
                {/* TEXT BOX */}
                <div className="txt-box">
                  {/* Title */}
                  <h5 className="h5-lg">Complete Localization Solution</h5>
                  {/* List */}
                  <ul className="simple-list">
                    <li className="list-item">
                      <p className="p-lg">
                        Support for dozens of file formats including DOCX, IDML, and JSON.
                      </p>
                    </li>
                    <li className="list-item">
                      <p className="p-lg">
                        Collaborative editor with real-time saving and change tracking.
                      </p>
                    </li>
                  </ul>
                </div>{" "}
                {/* END TEXT BOX */}
              </div>
            </div>{" "}
            {/* END TEXT BLOCK */}
            {/* CB WRAPPER */}
            <div className="col-lg-6 order-first order-lg-2">
              <div className="cb-wrapper">
                {/* CB HOLDER */}
                <div className="cb-holder wow fadeInLeft">
                  {/* CB BOX #1 */}
                  <div className="cb-single-box">
                    <p className="p-lg cb-header">Segments Translated</p>
                    <h2 className="h2-title-xs statistic-number">
                      <sup>+</sup>
                      <Counter end={950} duration={2000} />k
                    </h2>
                    <p className="p-md mt-5 ico-10">
                      <span className="green-color">
                        <span className="flaticon-" /> 12.4%
                      </span>{" "}
                      increase this month
                    </p>
                  </div>
                  <hr className="divider" />
                  {/* CB BOX #2 */}
                  <div className="cb-single-box">
                    <ul className="simple-list">
                      <li className="list-item">
                        <p className="p-md">
                          Boost your productivity with automated pre-translation.
                        </p>
                      </li>
                      <li className="list-item">
                        <p className="p-md">
                          Never lose progress with our auto-save editor.
                        </p>
                      </li>
                    </ul>
                  </div>
                  {/* CB BOX #3 */}
                  <div className="cb-single-box cb-box-rounded bg-green white-color mt-25">
                    <h4 className="h4-lg">99.9%</h4>
                    <p className="p-lg">Uptime & Reliability</p>
                  </div>
                </div>{" "}
                {/* END CB HOLDER */}
                {/* CB SHAPE */}
                <div className="cb-shape-1">
                  <img
                    className="img-fluid"
                    src="/images/bg-shape-1.png"
                    alt="content-image"
                  />
                </div>
                {/* CB SHAPE */}
                <div className="cb-shape-2">
                  <img
                    className="img-fluid"
                    src="/images/bg-shape-2.png"
                    alt="content-image"
                  />
                </div>
              </div>
            </div>{" "}
            {/* END CB WRAPPER */}
          </div>
        </div>{" "}
        {/* END BOTTOM ROW */}
      </div>{" "}
      {/* End container */}
    </section>
  );
};

export default Fcontent3;
